import React from "react";
import styled from 'styled-components';
import PropTypes from 'prop-types';

const BtnWrapper = styled.div`
  display: inline-block;
  ${props => props.expand ? `
    min-width: 100%;
    max-width: 100%;
    qds-button {
      min-width: 100%;
      max-width: 100%;
    }
  ` : ''}
`;

class Button extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onClick = props.onClick ? props.onClick : (event) => event;
  }

  static propTypes = {
    id: PropTypes.string
  }

  handleClick(event) {
    this.onClick(event);
  }

  render() {
    const buttonProps = {
      ...this.props
    };

    if (!buttonProps.disabled) {
      delete buttonProps['disabled'];
    }

    if (this.props.id) {
      buttonProps['id'] = this.props.id;
    }
    return (
      <BtnWrapper expand={this.props.expand}>
        <qds-button
          size="large"
          {...buttonProps}
          text={this.props.children}
          onClick={this.handleClick.bind(this)}
        ></qds-button>
      </BtnWrapper>
    );
  }
}

export default Button;
